export default "__VITE_ASSET__Aorkee3G__"